import {Component, OnDestroy, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {NzMessageService, NzModalService} from 'ng-zorro-antd';
import {UploaderComponent} from '../../shared/uploader';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {DistributorsService, RootService} from '../../services';
import {NzNotificationService} from 'ng-zorro-antd/notification';

interface ItemData {
  id: number;
  name: string;
  age: number;
  address: string;
}

@Component({
  selector: 'app-distributors',
  templateUrl: './distributors.component.html',
  styleUrls: ['./distributors.component.scss']
})
export class DistributorsComponent implements OnInit, OnDestroy {

  data = []
  pageIndex = 1;
  pageSize = 10;
  name: string;
  phone: string;
  // tslint:disable-next-line:variable-name
  tax_code: string;
  city: any;
  city1: any;
  area_id: any;
  area_new_id: any;
  changeAction;
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  listOfDisplayData: ItemData[] = [];
  listOfAllData
  mapOfCheckedId: { [key: string]: boolean } = {};
  // tslint:disable-next-line:variable-name

  loading = false;
  total: number;
  query;
  ids: any[] = [];
  imageFalse = [];

  // @ts-ignore
  @ViewChild('addDistributors') addDistributors;
  // @ts-ignore
  @ViewChild('modalDelete') modalDelete;
  unsubscribe$ = new Subject<void>();

  constructor(
    private router: Router,
    // private store: Store<fromInformationCtv.CtvState>,
    private distributorsService: DistributorsService,
    private rootService: RootService,
    private message: NzMessageService,
    private notification: NzNotificationService,
  ) {

  }

  ngOnInit(): void {

    this.notification.config({
      nzPlacement: 'bottomRight'
    });
    this.rootService.listCities().pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      this.city = res.data.items;
    });
    this.rootService.getLocationNew({type: 1}).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      this.city1 = res.data.data;
    });
    this.loadData();
    // test
  }

  async loadData(ms = 0) {
    this.loading = true;
    this.query = {
      name: this.name ? this.name.trim() : '',
      phone: this.phone ? this.phone.trim() : '',
      tax_code: this.tax_code ? this.tax_code.trim() : '',
      area_id: this.area_id ? this.area_id : '',
      area_new_id: this.area_new_id ? this.area_new_id : '',
      page: this.pageIndex,
      page_size: this.pageSize
    };
    await this.sleep(ms);
    this.distributorsService.list(this.query).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
        this.loading = false;
        this.total = res.data.totalElement;
        this.listOfAllData = res.data.items;

        if (res.data.items.length === 0 && this.pageIndex > 1) {
          this.pageIndex = this.pageIndex - 1;
          this.loadData();
        }
      },
      err => {
        this.loading = false;
        this.notification.create(
          'error',
          'Thất bại',
          err
        );
      });

  }

  search() {
    this.pageIndex = 1;
    this.loadData();
  }

  setName(data) {
    const text = {
      label: 'Xóa nhà phân phối',
      // tslint:disable-next-line:max-line-length
      value: ' <p class="mrb-10">Hệ thống sẽ gỡ toàn bộ sản phẩm của bạn khỏi nhà phân phối <span class="colorDelete">' + data.name + '</span>. Bạn có chắc chắn muốn xoá nhà phân phối?</p>\n'
    };
    this.modalDelete.showModal(text, data.id , data);

  }

  eventDelete(value) {
    const body = {
      body: {
        ids: value,
      }
    };
    this.distributorsService.deleteDistributor(body).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      if (res.code === 1) {
        this.notification.create(
          'success',
          'Thành công',
          'Xóa nhà phân phối thành công'
        );
        this.mapOfCheckedId = {};
        this.ids = [];
        this.modalDelete.handleCancel();
        this.loadData(500);
      } else {
        this.notification.create(
          'warning',
          'Cảnh báo',
          res.message
        );
      }
      this.modalDelete.success();

    }, (err) => {
      this.notification.create(
        'error',
        'Thất bại',
        err
      );
      this.modalDelete.success();

    });
  }

  deleteProduct() {
    const text = {
      label: 'Xóa nhà phân phối',
      // tslint:disable-next-line:max-line-length
      value: '<p>Bạn có chắc chắn muốn xoá danh sách nhà phân phối</p>'
    };

    this.modalDelete.showModal(text, this.ids);
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  reset() {
    this.pageIndex = 1;
    this.name = undefined;
    this.phone = undefined;
    this.tax_code = undefined;
    this.area_id = undefined;
    this.area_new_id = undefined;
    this.loadData();
  }

  loadDataChild($event: any) {
    this.loadData(1000);
  }


  currentPageDataChange($event: ItemData[]): void {
    this.data = []
    this.listOfDisplayData = $event;
    this.refreshStatus();
  }

  refreshStatus(data?): void {
    if (data) {
      const index = this.data.findIndex(z => z.id === data.id);
      index === -1 ? this.data.push({tax_code: data.tax_code, name: data.name}) : this.data.splice(index, 1);
    }

    if (this.listOfDisplayData.length > 0) {
      this.isAllDisplayDataChecked = this.listOfDisplayData.every(item => this.mapOfCheckedId[item.id]);
    } else {
      this.isAllDisplayDataChecked = false;
    }
    this.isIndeterminate =
      this.listOfDisplayData.some(item => this.mapOfCheckedId[item.id]) && !this.isAllDisplayDataChecked;
    this.ids = [];
    for (const [key, value] of Object.entries(this.mapOfCheckedId)) {
      // tslint:disable-next-line:triple-equals
      if (value == true) {
        this.ids.push(key);
      }
    }
  }

  checkAll(value: boolean): void {
    this.listOfDisplayData.forEach(item => (this.mapOfCheckedId[item.id] = value));
    if (this.data.length === this.listOfDisplayData.length) {
      this.data = [];
      return;
    }
    this.data = this.listOfAllData.map(z => {
      return {name: z.name, tax_code: z.tax_code};
    });
    console.log(this.data)
    this.refreshStatus();
  }
  clickNumberProduct(data){

  }

  actionsButton() {
    if (this.changeAction === '1') {
      this.addDistributors.showModal();
    }
    if (this.changeAction === '2') {
      this.deleteProduct();
    }
    if (this.changeAction === '3') {
      this.exportExcel();
    }
  }

  /*Check link image error*/
  checkImageErr(imageError) {
    this.imageFalse.push(imageError);
  }

  showImage(id: any, imageLink) {
    if (!this.imageFalse.includes(id)) {
      // @ts-ignore
      window.open(imageLink, '_blank');
    }
  }

  /*End Check link image error*/

  exportExcel() {
    const query = {
      export_all: this.ids.length === 0,
      ids: this.ids.length !== 0 ? this.ids.toString() : '',
      name: this.name ? this.name.trim() : '',
      phone: this.phone ? this.phone.trim() : '',
      tax_code: this.tax_code ? this.tax_code.trim() : '',
      area_id: this.area_id ? this.area_id : '',
      page: this.pageIndex,
      pageSize: this.total
    };

    this.distributorsService.exportExcel(query).pipe(takeUntil(this.unsubscribe$)).subscribe((data) => {
      this.rootService.export(data, 'Danh sách nhà phân phối.xlsx');
    });
  }
  detailDistributor(data){

  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
